import { render } from "./Loged.vue?vue&type=template&id=1df2f4be&scoped=true"
import script from "./Loged.vue?vue&type=script&lang=js"
export * from "./Loged.vue?vue&type=script&lang=js"

import "./Loged.vue?vue&type=style&index=0&id=1df2f4be&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1df2f4be"

export default script